module.exports = __webpack_public_path__ + "media/images/mail/photo_sample-8e2ae71332c1c71a3007a5b5bed89082.jpg";